import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {DrawerHeader as RmwcDrawerHeader} from '@rmwc/drawer'
import '@rmwc/drawer/styles'

const StyledRmwcDrawerHeader = styled(RmwcDrawerHeader)`
  &&& {
    padding: 2rem 2rem 1rem 2rem;
  }
`

const DrawerHeader = ({children, ...otherProps}) => <StyledRmwcDrawerHeader {...otherProps}>{children}</StyledRmwcDrawerHeader>

DrawerHeader.propTypes = {
  children: PropTypes.any
}

export {DrawerHeader}
